// extracted by mini-css-extract-plugin
module.exports = {"container":"languages_container__2fK1v","languagesContainer":"languages_languagesContainer__2cihG","language":"languages_language__3Eh96"};